import React from 'react';
import SABadge from '../../components/SuperAdmin/SABadge';
import '../../assets/styles/SuperAdmin/SATheme.css';
import '../../assets/styles/SuperAdmin/SAOverview.css';

const SAOverview = ({ perms, modCount, SA_ROLES, SA_AUDIT_LOG, SA_ALL_USERS, setPage, greeting }) => {
    return (
        <div className="animate-in">
            <div className="sa-overview-hero">
                <div style={{ position: "relative", zIndex: 1 }}>
                    <h1 style={{ fontSize: 28, fontWeight: 800, margin: 0, marginBottom: 6, fontFamily: "'Sora'", color: "#fff" }}>{greeting}, Admin 🛡️</h1>
                    <p style={{ color: "rgba(255,255,255,0.55)", fontSize: 14, margin: 0, marginBottom: 20 }}>Super Admin Control Panel — Manage roles, privileges, users, and system security</p>
                    <div style={{ display: "flex", gap: 8 }}>
                        <SABadge color="red" dot>Super Admin Only</SABadge>
                        <SABadge color="green" dot>System Online</SABadge>
                        <SABadge color="blue" dot>{SA_ROLES.length} Roles Active</SABadge>
                        <SABadge color="orange" dot>{SA_ALL_USERS.length} Users Managed</SABadge>
                    </div>
                </div>
            </div>

            <div className="sa-stats-grid">
                {[
                    { v: String(SA_ROLES.length), l: "Active Roles", s: "2 admin · 4 standard", c: "var(--sa-red)" },
                    { v: String(SA_ALL_USERS.length), l: "Managed Users", s: (SA_ALL_USERS.filter(u => (u.status || '').toUpperCase() === "ACTIVE").length) + " active · " + (SA_ALL_USERS.filter(u => (u.status || '').toUpperCase() === "INACTIVE").length) + " inactive", c: "var(--sa-teal)" },
                    { v: String(modCount), l: "System Modules", s: "All operational", c: "var(--sa-accent)" },
                    { v: String(Object.values(perms).reduce((a, r) => a + Object.keys(r).length, 0)), l: "Permissions Set", s: "Across all roles", c: "var(--sa-orange)" },
                    { v: "5", l: "Active Portals", s: "Emp · HR · IT · PM · Intern", c: "var(--sa-green)" },
                ].map((s, i) => (
                    <div key={i} className="sa-stat-card" style={{ borderTop: `3px solid ${s.c}` }}>
                        <div className="sa-stat-value" style={{ color: s.c }}>{s.v}</div>
                        <div style={{ fontSize: 12, color: "var(--sa-muted)", marginTop: 4, fontWeight: 600 }}>{s.l}</div>
                        <div style={{ fontSize: 10, color: s.c, marginTop: 6, fontWeight: 600 }}>{s.s}</div>
                    </div>
                ))}
            </div>

            <div className="sa-overview-split">
                <div className="sa-card">
                    <div style={{ fontSize: 15, fontWeight: 700, fontFamily: "'Sora'", marginBottom: 16, display: "flex", alignItems: "center", gap: 8 }}>
                        Roles Overview
                        <span style={{ fontSize: 10, background: "rgba(229, 57, 53, 0.1)", color: "var(--sa-red)", padding: "2px 8px", borderRadius: 8, fontWeight: 700 }}>{SA_ROLES.length} roles</span>
                    </div>
                    {SA_ROLES.map(r => {
                        const p = perms[r.id] ? Object.values(perms[r.id]) : [];
                        const full = p.filter(x => x === "full").length, write = p.filter(x => x === "write").length, read = p.filter(x => x === "read").length;
                        return (
                            <div key={r.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 0", borderBottom: "1px solid var(--sa-border)" }}>
                                <div style={{ width: 36, height: 36, borderRadius: 10, background: r.color + "18", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{r.icon}</div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 13, fontWeight: 700, color: r.color }}>{r.name}</div>
                                    <div style={{ fontSize: 10, color: "var(--sa-muted)" }}>{r.users.length} user{r.users.length !== 1 ? "s" : ""}</div>
                                </div>
                                <div style={{ display: "flex", height: 6, width: 100, borderRadius: 3, overflow: "hidden" }}>
                                    <div style={{ width: `${(full / modCount) * 100}%`, background: "var(--sa-green)" }} />
                                    <div style={{ width: `${(write / modCount) * 100}%`, background: "var(--sa-orange)" }} />
                                    <div style={{ width: `${(read / modCount) * 100}%`, background: "var(--sa-blue)" }} />
                                    <div style={{ flex: 1, background: "var(--sa-border)" }} />
                                </div>
                                <div style={{ fontSize: 10, color: "var(--sa-dim)", width: 50, textAlign: "right" }}>{full + write + read}/{modCount}</div>
                                {r.locked && <SABadge color="red">Locked</SABadge>}
                            </div>
                        );
                    })}
                </div>

                <div className="sa-card">
                    <div style={{ fontSize: 15, fontWeight: 700, fontFamily: "'Sora'", marginBottom: 16, display: "flex", alignItems: "center", gap: 8 }}>
                        Recent Changes
                        <span style={{ fontSize: 10, background: "rgba(183, 28, 28, 0.1)", color: "var(--sa-accent)", padding: "2px 8px", borderRadius: 8, fontWeight: 700 }}>last 7 days</span>
                    </div>
                    {SA_AUDIT_LOG.slice(0, 6).map((log, i) => (
                        <div key={i} style={{ display: "flex", gap: 12, padding: "10px 0", borderBottom: i < 5 ? "1px solid var(--sa-border)" : "none", alignItems: "flex-start" }}>
                            <div style={{ width: 30, height: 30, borderRadius: 8, background: log.color + "18", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, flexShrink: 0 }}>{log.icon}</div>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: 12, fontWeight: 700, color: log.color }}>{log.action}</div>
                                <div style={{ fontSize: 11, color: "var(--sa-muted)", marginTop: 2 }}>{log.detail}</div>
                                <div style={{ fontSize: 10, color: "var(--sa-dim)", marginTop: 3 }}>{log.time}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="sa-overview-split">
                <div className="sa-card">
                    <div style={{ fontSize: 15, fontWeight: 700, fontFamily: "'Sora'", marginBottom: 16 }}>Portal Health</div>
                    {[
                        { name: "Employee Portal", users: "3 employees", status: "Operational", c: "var(--sa-green)", icon: "👤" },
                        { name: "HR Admin Portal", users: "1 HR admin", status: "Operational", c: "var(--sa-green)", icon: "👔" },
                        { name: "IT Admin Portal", users: "1 IT admin", status: "Operational", c: "var(--sa-green)", icon: "🖥️" },
                        { name: "PM Portal", users: "1 project manager", status: "Operational", c: "var(--sa-green)", icon: "📊" },
                        { name: "Intern Portal", users: "1 intern", status: "Operational", c: "var(--sa-green)", icon: "🎓" },
                    ].map((p, i) => (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 0", borderBottom: i < 4 ? "1px solid var(--sa-border)" : "none" }}>
                            <div style={{ width: 40, height: 40, borderRadius: 10, background: `${p.c}12`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>{p.icon}</div>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: 13, fontWeight: 700 }}>{p.name}</div>
                                <div style={{ fontSize: 11, color: "var(--sa-muted)" }}>{p.users}</div>
                            </div>
                            <SABadge color="green" dot>{p.status}</SABadge>
                        </div>
                    ))}
                </div>
                <div className="sa-card">
                    <div style={{ fontSize: 15, fontWeight: 700, fontFamily: "'Sora'", marginBottom: 16 }}>Quick Actions</div>
                    <div className="sa-quick-actions">
                        {[
                            { label: "Edit Permissions", icon: "📋", c: "var(--sa-accent)", tab: "matrix" },
                            { label: "Manage Roles", icon: "🛡️", c: "var(--sa-red)", tab: "roles" },
                            { label: "User Governance", icon: "👥", c: "var(--sa-teal)", tab: "users" },
                            { label: "View Audit Log", icon: "📜", c: "var(--sa-orange)", tab: "audit" },
                            { label: "Security Policies", icon: "🔐", c: "var(--sa-gold)", tab: "security" },
                            { label: "Portal Health", icon: "🌐", c: "var(--sa-green)", tab: "portals" },
                        ].map((a, i) => (
                            <div key={i} onClick={() => setPage(a.tab)} className="sa-action-card" style={{ background: `${a.c}0a`, border: `1px solid ${a.c}20` }}>
                                <span style={{ fontSize: 20 }}>{a.icon}</span>
                                <span style={{ fontSize: 12, fontWeight: 700, color: a.c }}>{a.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SAOverview;
